import React, {Component} from 'react';
import './perfil.css';
import {Link, Redirect} from 'react-router-dom';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {deleteUser} from '../../../actions/index'

class SegurancaInfo extends Component{

    constructor() {
        super();
        this.state = {
            delete : false,
            selectedOption: '',
            texArea: ''
        }
    }

    onDeleteUser = (event) => {
        event.preventDefault();
        this.props.deleteUser(this.state.texArea, this.state.selectedOption);
        this.setState({delete : true})
    }

    onSelectDeleteOption = (event) => {
        this.setState({selectedOption : event.target.value})
        console.log(event.target.value)
    }

    onTextAreaChange = (event) => {
        this.setState({texArea : event.target.value})
    }

    render(){
        if(this.state.delete === true) {
            return(
                <Redirect to = { {pathname: '/login' }}/>

            )
        }
        return(
            <div>
                <h3 className="h-gerais"> Segurança </h3>
                <div className="dados-pessoais">
                    <h4 className="titulo-dados"> ENCERRAR A CONTA NO WEBJOB </h4>
                    <div className="pl-3 pr-5 terms-security">
                        <p>Se você encerrar sua conta no WEBJOB você não será capaz de fazer login, nem de receber qualquer comunicação do site. 
                            Fechar sua conta significa que você não terá acesso aos profissionais com quem você está se consultando
                            (os que você já se consultou e os que você está se consultando atualmente).
                        </p>
                        <p>
                            Preencha o formulário abaixo com seus comentários. Eles vão ajudar a melhorar o Webjob o futuro.
                        </p>
                    </div>
                    <form onSubmit = { this.onDeleteUser}>
                        <h4 className="titulo-dados">Motivo do encerramento </h4>    
                        <div className="seguranca-form-div form-group col-md-6">
                            <select onChange = {this.onSelectDeleteOption} className="form-control " id="exampleFormControlSelect1">
                                <option defaultValue>Escolha uma opção</option>
                                <option value = "Não encontrei os Consultores que estava procurando" >Não encontrei os Consultores que estava procurando</option>
                                <option value = "As consultorias estavam muito caras pra mim">As consultorias estavam muito caras pra mim</option>
                                <option value = "Eu pensei que o Webjob era outra coisa">Eu pensei que o Webjob era outra coisa</option>
                                <option value = "Outro motivo">Outro motivo</option>
                            </select>
                        </div>
                        <h4 className="titulo-dados">Comentários </h4>
                        <div className="px-3 terms-security">
                            <p>Por favor, diga os motivos pelos quais você decidiu encerrar sua conta e/ou nos deixe
                                sugestões para melhorias que você acredita que possamos implementar no Webjob. (Opcional)
                            </p>
                        </div>
                        <div className="form-group col-md-11 pb-3 comment-security-container">
                            <textarea 
                                onChange = {this.onTextAreaChange} 
                                className="form-control textarea-security-comment" 
                                id="exampleFormControlTextarea1" 
                                rows="3"
                                placeholder="Digite aqui seu comentário"></textarea>
                        </div>
                        <div id="security-button-container">
                            <button type="submit" className="btn btn-custom btn-custom-submit">Sim, quero encerrar minha conta</button>
                            <button type="submit" className="btn btn-custom btn-custom-orange">Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({deleteUser}, dispatch);
}
export default connect(null, mapDispatchToProps)(SegurancaInfo)
